/** Channel the code was actually sent through. */
export type StepUpMethod = 'OTP_EMAIL' | 'TOTP';

/**
 * `POST /v1/auth/step-up/challenge` result.
 *
 * Always drive the prompt from this, never from the 403's `details.method`:
 * the 403 hard-codes `OTP_EMAIL` while the challenge picks the channel (a user
 * with an authenticator enrolled gets TOTP, and no email is sent).
 */
export interface StepUpChallenge {
  challengeId: string;
  method: StepUpMethod | string;
  /** Masked destination, e.g. "e***@x.ng". Empty/absent for TOTP. */
  destination: string | null;
  /**
   * What the user is confirming, e.g. "New payout account Access Bank ••••6789".
   * Server-owned, never empty, and the same text the OTP email carries — render
   * it verbatim so the dialog and the email tell one story.
   */
  scopeHint: string;
  expiresAt: string;
}

export class RequestStepUpChallenge {
  static readonly type = '[StepUp] Request Challenge';
  constructor(
    public readonly operation: string,
    /** The EXACT body the protected request will send (byte-identical on retry). */
    public readonly payload: unknown
  ) {}
}

export class SubmitStepUpCode {
  static readonly type = '[StepUp] Submit Code';
  constructor(
    public readonly challengeId: string,
    public readonly code: string
  ) {}
}

/** Issue a fresh challenge for the same operation + payload. */
export class ResendStepUpCode {
  static readonly type = '[StepUp] Resend Code';
}

export class CancelStepUp {
  static readonly type = '[StepUp] Cancel';
}

export class ClearStepUp {
  static readonly type = '[StepUp] Clear';
}
